// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2364":"a2967aaf","6272":"5effb909","6589":"d661c348","8126":"786de30e","8253":"5effb909"}[chunkId] + ".chunk.css";
};